<template>
  <div>
    <ValidationObserver ref="form">
      <div class="container-fluid">
        <div class="row d-flex justify-content-start">
          <div class="col-12">
            <SectionTitle
              has-line
              content="Información General"
              class="responsive-section-title"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4  pt-3">
            <custom-date-picker
              v-model="value.requestDate"
              format="dd/MMM./yyyy"
              label="Fecha de Solicitud:"
              :disabled="dateDisabled || readOnly"
              class-container=""
            />
          </div>
          <div class="col-12 col-md-4  pt-3">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="value.solicitorName"
                label="Nombre Solicitante:"
                :error="errors[0]"
                :custom-error-msg="getError('0733')"
                :disabled="readOnly"
              />
            </ValidationProvider>
          </div>
          <div class="col-12 col-md-4  pt-3">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="value.cseeDirectorName"
                label="Director(a) del CSEE:"
                :error="errors[0]"
                :custom-error-msg="getError('0730')"
                :disabled="readOnly"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4  pt-3">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="value.solicitorPosition"
                :options="solicitorPositions"
                label="Puesto Solicitante:"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                class="height-fixed"
                :error="errors[0]"
                :custom-error-msg="getError('0734')"
                :disabled="readOnly"
              />
            </ValidationProvider>
          </div>
          <div class="col-12 col-md-4  pt-3">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="value.schoolDirectorName"
                label="Director Escolar:"
                :error="errors[0]"
                :custom-error-msg="getError('0731')"
                :disabled="readOnly"
              />
            </ValidationProvider>
          </div>  
            <div class="col-12 col-md-4  pt-3">
            <ValidationProvider v-slot="{ errors }" rules="required">

                <CustomInput
                  v-model="value.solicitorPhone"
                  label="Número Teléfono:"
                  :mask-type="'Phone'"
                  placeholder="(__) __-____"
                  :disabled="readOnly"
                  :error="errors[0]"
                  :custom-error-msg="getError('0742')"
                />

            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pt-3">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomTextArea
                v-model="value.comments"
                label="Comentario:"
                :maxlength="2000"
                show-char-count
                :count-classes="['d-block text-right']"
                :error="errors[0]"
                :custom-error-msg="getError('0732')"
                :disabled="readOnly"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import CustomTextArea from 'CustomTextArea';
import { getATSolicitorPositiions } from '@/modules/request-tech-service-assistance/api';
import resourcesService from '@/services/resources.js';

export default {
  name: 'GeneralInformation',
  components: {
    ValidationProvider,
    ValidationObserver,
    SectionTitle,
    CustomDatePicker,
    CustomInput,
    CustomDropDown,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateDisabled: true,
      solicitorPositions: [],
      resources: [],
    };
  },
  computed: {},
  methods: {
    getError(code) {
      let message = this.resources[code];

      return message ? message.replace(`(${code})`, '') : '';
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '0729',
        '0730',
        '0731',
        '0732',
        '0733',
        '0734',
        '0742'
      ]);
    },
    async getATSolicitorPositiions() {
      await getATSolicitorPositiions().then(({ data }) => {
        this.solicitorPositions = data;

        if (this.readOnly) {
          this.value.solicitorPosition = this.solicitorPositions.find(
            (x) => x.id == this.value.solicitorPositionId
          );
        }
      });
    },
  },
  async mounted() {
    await this.getATSolicitorPositiions();
    await this.loadResources();
  },
};
</script>

<style scoped>
::v-deep .data-label,
.input-display > label {
  color: #11291b !important;
}
::v-deep label.data-name {
  color: #11291b !important;
}

@media (max-width: 765px) {
  .responsive-section-title >>> .tag-badge-title-info {
    font-size: 12px;
  }
  ::v-deep .input-display {
    margin-left: 0px !important;
  }
}
</style>
